import { Component, Input } from '@angular/core';
import { Warehouse } from '../../models/warehouse.model';
import { DataFormModel } from '../../models/data-form-model.model';
import { FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { WarehouseService } from '../../services/warehouse.service';
import { UtilService } from '../../services/util.service';

@Component({
  selector: 'app-warehouse-modal',
  templateUrl: './warehouse-modal.component.html',
  styleUrl: './warehouse-modal.component.scss'
})
export class WarehouseModalComponent {

  @Input() idBranch: string = '';
  @Input() warehouse?: Warehouse;

  public dataForm: DataFormModel = {
    name: {
      value: '',
      type: 'text',
      label: 'Nombre del almacén',
      requiredMessage: 'Por favor, ingresa el nombre del almacén',
      required: true,
      validators: [Validators.required]
    }
  };

  public formWarehouse!: FormGroup;
  public submitted: boolean = false;
  public loading: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    public warehouseService: WarehouseService,
    public utilService: UtilService
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  get f() {
    return this.formWarehouse.controls;
  }

  async loadData() {
    this.loading = true;

    if (this.warehouse) {
      this.dataForm = {
        ...this.dataForm
      };

      for (let key of Object.keys(this.dataForm)) {
        if (key in this.warehouse) {
          const standardKey = key as keyof typeof this.warehouse;
          this.dataForm[key].value = this.warehouse[standardKey]!;
        }
      }
    }

    this.formWarehouse = this.utilService.buildForm(this.dataForm);
    this.loading = false;
  }

  async onSubmit() {
    this.submitted = true;

    if (this.formWarehouse.invalid) {
      return;
    }

    if (this.warehouse) {
      await this.update();
    } else {
      await this.create();
    }
  }

  async create() {
    const flag = await this.warehouseService.create(
      this.idBranch,
      this.formWarehouse.value
    );

    if (flag) {
      for (let key of Object.keys(this.dataForm)) {
        this.dataForm[key].value = '';
      }
      this.activeModal.close();
    }
  }

  async update() {
    this.formWarehouse.value.idWarehouse = this.warehouse!.idWarehouse;
    this.formWarehouse.value.idBranch = this.warehouse!.idBranch;

    const flag = await this.warehouseService.update(
      this.formWarehouse.value
    );

    if (flag) {
      for (let key of Object.keys(this.dataForm)) {
        this.dataForm[key].value = '';
      }
      this.activeModal.close();
    }
  }

}
